module.exports = "<div>\r\n    <table class=\"middleContainer\">\r\n        <tr>\r\n            <td>\r\n                <prevent></prevent>\r\n            </td>\r\n        </tr>\r\n    </table>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/prevent/preventIndex.html
// module id = 178
// module chunks = 0